import React from 'react'
import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'

const ChevronRight = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                id="arrow"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.0604 5.93933L11.9391 8.06065L23.8785 20L11.9391 31.9393L14.0604 34.0606L28.1211 20L14.0604 5.93933Z"
                fill="currentColor"
            />
        </Icon>
    )
}

ChevronRight.propTypes = {onClick: PropTypes.func}

export default ChevronRight
